import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-rows: 50px 3fr;
  grid-template-columns: minmax(285px, 2fr) 1fr minmax(400px, 3fr);
  grid-template-areas:
    'tc tc c3'
    'c1 c2 c3';
  width: 100%;
  height: 280px;
  border: 1px solid #c7c7c7;
  border-radius: 8px;
  background-color: #f7f7f7;
  margin-bottom: 10px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

export const TitleContainer = styled.div`
  display: grid;
  grid-area: tc;
  margin-left: 10px;
  margin-top: 15px;
  grid-template-columns: minmax(275px, 400px) 200px 200px;
  grid-template-areas: 't1 t2 t3';
`;

export const T1 = styled.div`
  grid-area: t1;
  justify-self: left;
`;

export const T2 = styled.div`
  grid-area: t2;
`;

export const T3 = styled.div`
  grid-area: t3;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ColumnOneContainer = styled.div`
  grid-area: c1;
  margin-left: 10px;
  border-right: 1px solid #c7c7c7;
  margin-bottom: 10px;
  margin-right: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export const ColumnTwoContainer = styled.div`
  grid-area: c2;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 380px;
  min-width: 200px;
  max-width: 380px;
  height: 90%;
  margin-top: 0px;
  margin-left: 10px;
  padding: 10px;
  border: 1px solid #c7c7c7;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.15) inset;
  & .top {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  & .bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
  }
`;

export const SmallChart = styled.div`
  grid-area: sC1;
  justify-items: center;
  justify-content: center;
  align-content: center;
`;

export const ColumnThreeContainer = styled.div`
  grid-area: c3;
  display: grid;
  padding-top: 0px;
  grid-template-areas:
    'title'
    'wrap';

  > div:first-child {
    margin-top: 10px;
    margin-bottom: -10px;
  }
`;

export const ChartContainer = styled.div`
  grid-area: wrap;
  display: flex;
  overflow-x: auto;
`;

export const Chart = styled.div`
  display: grid;
  column-gap: 10px;
  grid-template-rows: 160px 80px;
  grid-template-areas:
    'svgcircle'
    'laneLabel';
`;

export const LaneLabel = styled.div`
  grid-area: laneLabel;
  justify-self: center;
  width: 10vw;
  flex: auto;
  vertical-align: top;
  text-align: center;
  padding: 10px;
  &:hover {
    text-decoration: underline;
  }
`;

export const List = styled.div`
  line-height: 30px;
  flex-direction: column;
  display: flex;
  max-width: 275px;
  width: 100%;
  & .button {
    margin: 1px 0px;
    width: 100%;
  }
`;
